'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Position = function Position(_ref) {
  var id = _ref.id,
    markerStyle = _ref.markerStyle,
    position = _ref.position;
  return _react2.default.createElement('div', {
    id: id,
    style: {
      background: markerStyle.color,
      height: '100%',
      left: position * 100 + '%',
      position: 'absolute',
      top: 0,
      transition: 'all 20ms ease-in-out',
      width: markerStyle.width + 'px'
    }
  });
};
Position.defaultProps = {
  markerStyle: {
    color: '#fff',
    width: 4
  },
  position: 0
};
Position.propTypes = {
  id: _propTypes2.default.string,
  markerStyle: _propTypes2.default.shape({
    color: _propTypes2.default.string,
    width: _propTypes2.default.number
  }),
  position: _propTypes2.default.number
};
exports.default = Position;